<div class="modal-body ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
	    {{getRessource('modalHeader')}}
    </span>
		<div class="content layout-auto-1-auto width-900">
			<!-- Search Header -->
			<exg-search-bar (Search)="caseTable.search($event)" [placeholder]="getRessource('SearchHolder')"
			                class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="caseTable.loadData()" class="search-action fal fa-sync"></i>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-filter"
                 [class.fas]="caseTable.uiFilterAktiv(1).length > 0"
                 [class.fal]="caseTable.uiFilterAktiv(1).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCcaseTableFilterControl
                              (onActivateFilter)="caseTable.pageChanged(1);popup.close()"
                              [MetaInfo]="caseTable.MetaInfo"
                              [visibility]="popup.visibility !== 'hidden'"
                              [showFilter]="true" [uiFilter]="caseTable.uiFilter"
                              [uiSort]="caseTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>

          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-sort-alt"
                 [class.fas]="caseTable.uiSortAktiv().length > 0"
                 [class.fal]="caseTable.uiSortAktiv().length === 0"></i>
            </ng-template>

            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCcaseTableSortControl
                              (onActivateFilter)="caseTable.pageChanged(1);popup.close()"
                              [visibility]="popup.visibility !== 'hidden'"
                              [MetaInfo]="caseTable.MetaInfo"
                              [showSort]="true" [uiFilter]="caseTable.uiFilter"
                              [uiSort]="caseTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>

          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-binoculars"
                 [class.fas]="caseTable.uiFilterAktiv(2).length > 0"
                 [class.fal]="caseTable.uiFilterAktiv(2).length === 0"></i>
            </ng-template>

            <ng-template #contentTemplate let-popup>
              <app-exg-filter (onActivateFilter)="caseTable.pageChanged(1);popup.close()"
                              [MetaInfo]="caseTable.MetaInfo" #VCcaseTableSearchControl
                              [visibility]="popup.visibility !== 'hidden'"
                              [showSearch]="true" [uiFilter]="caseTable.uiFilter"
                              [uiSort]="caseTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <i class="search-action fal fa-list"
             [class.c-green]="caseTable.multiSelection"
             (click)="caseTable.toggleMultiSelection()"
             [tooltip]="getRessource('TooltipToggleMultiSelection')"  flow="left">
          </i>
          <i class="search-action fal fa-gears"
             (click)="openTableSettings($event)">
          </i>
          <exg-table-settings #tableDefinitionSettings
                              [tableDef]="caseTable.tableDefinition"
                              [metaInfo]="caseTable.MetaInfo"
                              localStorageID="caseTableModal">
          </exg-table-settings>
        </ng-template>
			</exg-search-bar>
			<!-- DataTable -->
			<div class="content height-800">
					<exg-table #VCcaseTableV2
					           (RowChange)="caseTable.selectionChanged($event)"
					           (FilterActivation)="caseTable.loadData()"
					           [selectSource]="caseTable.selectedRows"
					           [selectKey]="caseTable.selectKey"
					           [rowSource]="caseTable.data"
					           [tableDef]="caseTable.tableDefinition"
					           [distinctTableName]="'Auftraege'"
					           [metaInfo]="caseTable.MetaInfo"
					           [displayState]="caseTable.state"
					           class="content"
					           [allowMultiSelection]="caseTable.multiSelection"
					           [allowSingleSelection]="!caseTable.multiSelection"
					           (loadDistinct)="caseTable.getDistinctData($event)"
					           [distinctData]="caseTable.distinctData">
					</exg-table>
			</div>
			<!-- Pager -->
			<exg-pager (PageChange)="caseTable.pageChanged($event)"
			           [pagingSource]="caseTable.paging"
			           class="span-layout app-pager">
 				<ng-template #leftTemplate>
 					<app-exg-dropdown *ngIf="preFilterDefinition && preFilterDefinition.length" class="typo-small" [list]="preFilterDefinition" elementclass="typo-left" maxHeight="250px"
 					                  [label]="selectedMod?.caption" position="abovecenter" listdisplay="caption"
 					                  (change)="changePreFilterMod($event.value)">
 					</app-exg-dropdown>
 					<app-exg-dropdown *ngIf="preFilterDefinition && preFilterDefinition.length" class="typo-small" [list]="selectedMod?.types" elementclass="typo-left" maxHeight="250px"
 					                  [label]="selectedType?.caption" position="abovecenter" listdisplay="caption"
 					                  (change)="changePreFilterType($event.value)">
 					</app-exg-dropdown>
 				</ng-template>
			</exg-pager>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="action()"
			        [disabled]="dirty()"
			        class="md-btn">
				{{getGlobal('Save')}}
			</button>
			<button (click)="close()" class="md-btn">
				{{getGlobal('Close')}}
			</button>
		</div>
	</div>
</div>
